import React from 'react';
import Ctaegory from '../sections/sec-category';
const Categorypage = () => {
    return ( 
        <>
        <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Ctaegory />
        </section>


        </>
     );
}
 
export default Categorypage;